import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet(() => ({
  // Невидимое поле: держит фокус и системную клавиатуру
  hiddenInput: {
    height: rh(1),
    opacity: 0,
    position: 'absolute',
    width: rw(1),
  },
}))
